import React from "react";
// import styles from "./CommonBanner.module.css";
import BannerBackground from "components/UI/icons/BannerBackground";
import useWindowWidth from "helpers/useWindowWidth";

function CommonBanner({ title, image }) {
  console.log("111 title", title);
  const width = useWindowWidth();
  return (
    <div className="bannerOuter">
      <div className="imageDiv">
        <img src={image} alt="" />
        {/* <img src="/img/banner-style.svg" className="bannerDesign" alt="" /> */}
        {width > 868 && <BannerBackground className="bannerDesign" />}
      </div>
      <div className="titleOuter">
        <h1>{title}</h1>
      </div>
    </div>
  );
}

export default CommonBanner;
